import {useState} from "react";
import {SkeletonViewImage} from "../Skeleton";
import {ImageContainer, ImageView} from "../../pages/Campaign/style";

export const Image = (props: any) => {
    const [loading, setLoading] = useState(true);
    return (<ImageContainer style={{...(props.loadingStyle || {})}} className={loading ? 'loading' : 'loaded'}>
        {loading ? (<SkeletonViewImage active></SkeletonViewImage>) : null}
        <ImageView {...props} onLoad={() => {
            setLoading(false);
        }}/>
    </ImageContainer>)
}